<script lang="ts">
	import type { Snippet } from 'svelte';

	type Props = {
		children: Snippet;
		onclick?: () => void;
		type?: 'primary' | 'outline';
		wide?: boolean;
		tabindex?: number;
		class?: string;
		disabled?: boolean;
	};

	let { type, wide = false, children, onclick, ...restProps }: Props = $props();
</script>

<button {onclick} {...restProps} class={`${type} ${wide ? 'wide' : ''} ${restProps.class || ''}`}>
	<div class="fancy">
		<span class="on-top">
			{@render children()}
		</span>
	</div>
</button>

<style>
	button {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 0.75rem 1.25rem;
		border-radius: var(--border-radius-md);
		font-size: 1rem;
		line-height: 1.5;
		transition: all 0.2s ease;
		cursor: pointer;
		position: relative;
		color: rgba(255, 255, 255, 0.6);
		border: 1px solid currentColor;
	}

	.primary {
		background-color: #3b82f6;
		color: white;
	}

	.primary:hover {
		background-color: #2563eb;
	}

	button:hover {
		background-color: rgba(255, 255, 255, 0.8);
		color: var(--black);
	}

	button:disabled {
		opacity: 0.4;
		cursor: default;
	}

	.wide {
		width: 100%;
	}

	.fancy {
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}

	.on-top {
		position: relative;
		z-index: 1;
	}
</style>
